export var DATE_PICKER_FORMAT = 'MM/DD/YYYY';
export var SERVER_TIMEZONE = 'America/New_York';
//# sourceMappingURL=constants.js.map